"use client";
import {AspectRatio, Heading, Box, Flex, Text} from "@chakra-ui/react";
import Image, {StaticImageData} from "next/image";
import {ADVANCE_NETWORK_CARD_DATA} from "./constants";

const AdvanceNetworkOptions = () => {
  return (
    <Flex flexWrap="wrap" justifyContent="center" gap={"2%"} data-cy={"section-options"}>
      {ADVANCE_NETWORK_CARD_DATA.map((data, index) => (
        <Box key={index} minWidth={"320px"} maxWidth={"23%"} marginBottom={6}>
          <AdvanceNetworkCard title={data.title} image={data.image} test={data.test} />
        </Box>
      ))}
    </Flex>
  );
};

export default AdvanceNetworkOptions;

type Props = {
  title: string;
  image: StaticImageData;
  content?: string;
  test?: string;
};
export const AdvanceNetworkCard = (props: Props) => {
  const {title, image, content, test} = props;
  return (
    <Box
      p={4}
      boxShadow={"md"}
      border={"1px solid #aaa"}
      borderRadius={"8px"}
      transition={"0.15s"}
      _hover={{
        transform: "scale(1.03)",
        boxShadow: "lg",
      }}
      height={"350px"}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={4}
      data-cy={`card-${test}`}
    >
      <AspectRatio ratio={10 / 8} width="80%">
        <Image
          src={image}
          alt={title}
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC"
          style={{
            width: "220px",
            height: "180px",
            objectFit: "contain",
            objectPosition: "center",
            margin: "0 auto",
          }}
        />
      </AspectRatio>
      <Heading textAlign={"center"} fontSize={{base: "md", lg: "lg"}} color={"gray.700"}>
        {title}
      </Heading>
      <Text fontSize={{base: "md", lg: "lg"}} color={"gray.700"} textAlign={"center"}>
        {content}
      </Text>
    </Box>
  );
};
